import { apiClient, unwrap } from './client';

/**
 * SIMG-TRACABILITE-PIECES-2026-001 — Client API des pièces produites.
 * Consultation back-office et téléchargement de la feuille A4 imprimable.
 */

export type StatutPiece = 'sur_parc' | 'expediee' | 'posee' | 'defectueuse';

export interface PieceProduite {
  id:               string;
  codeCanonique:    string;   // ex "LB260922-0001-K7"
  affichage:        string;   // ex "LB · 22-09-26 · 0001-K7"
  numeroSequentiel: number;
  dateFab:          string;   // "2026-09-22"
  statut:           StatutPiece;
}

export const piecesApi = {
  listerParLot: (lotId: string) =>
    apiClient.get(`/production/lots/${lotId}/pieces`).then(unwrap<PieceProduite[]>),

  /**
   * Télécharge le PDF feuille de codes et déclenche le save via un blob download.
   * Le JWT est injecté par l'interceptor axios.
   */
  telechargerFeuille: async (lotId: string, lotReference: string) => {
    const res = await apiClient.get(`/production/lots/${lotId}/codes-feuille`, {
      responseType: 'blob',
      _silentError: true,
    });
    const disposition = String(res.headers['content-disposition'] ?? '');
    const match       = disposition.match(/filename="([^"]+)"/);
    const filename    = match?.[1] ?? `${lotReference}-codes.pdf`;
    const url = URL.createObjectURL(res.data);
    const a   = document.createElement('a');
    a.href     = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
    return filename;
  },
};
